import type { Ctx } from "../../types";
import { Action, invalidate, removeQueryParams } from "gg-wf-scripts";
import { toast } from "../../toast";

export const delete_job_opening: Action<Ctx> = async (
  { sb },
  _data,
  params
) => {
  const job_opening_id = params.get("id");
  if (!job_opening_id) return { ok: false, error: "Missing id in URL" };

  const { error } = await sb.functions.invoke(`api/jobs/${job_opening_id}`, {
    method: "DELETE",
  });
  if (error) {
    toast({ variant: "error", text: "Job delete failed. Try again" });
    return { ok: false, error: error.message };
  }
  invalidate("jobs");
  removeQueryParams(["modal", "id"]);
  toast({ variant: "success", text: "Job deleted!" });
  return { ok: true };
};
